const isLocal = document.location.hostname === 'localhost';
// const isDev = document.location.hostname === 'uprocedures.dev' || isLocal;
// const isQa = document.location.hostname === 'qa.uprocedures.com' || isLocal;
const isProd = document.location.hostname === 'uprocedures.com';


export const FEATURE_SHOW_DEVICE_ABTESTS = isLocal;
export const FEATURE_SHOW_TEST_STATUS = isLocal;
export const FEATURE_SHOW_TEST_MODE = !isProd;
